export default __webpack_public_path__ + "static/media/background.6fb11d6b.png";